var cov_1khmcguwtd = function () {
  var path = "/Users/spana/SHEIN/shineout/src/utils/dom/ready.ts",
      hash = "aaf44813b1b856805b113e967746dce0a67b608e",
      Function = function () {}.constructor,
      global = new Function('return this')(),
      gcv = "__coverage__",
      coverageData = {
    path: "/Users/spana/SHEIN/shineout/src/utils/dom/ready.ts",
    statementMap: {
      "0": {
        start: {
          line: 2,
          column: 2
        },
        end: {
          line: 2,
          column: 23
        }
      },
      "1": {
        start: {
          line: 2,
          column: 17
        },
        end: {
          line: 2,
          column: 23
        }
      },
      "2": {
        start: {
          line: 3,
          column: 2
        },
        end: {
          line: 6,
          column: 3
        }
      },
      "3": {
        start: {
          line: 3,
          column: 41
        },
        end: {
          line: 3,
          column: 51
        }
      },
      "4": {
        start: {
          line: 5,
          column: 4
        },
        end: {
          line: 5,
          column: 59
        }
      }
    },
    fnMap: {
      "0": {
        name: "(anonymous_0)",
        decl: {
          start: {
            line: 1,
            column: 15
          },
          end: {
            line: 1,
            column: 16
          }
        },
        loc: {
          start: {
            line: 1,
            column: 57
          },
          end: {
            line: 7,
            column: 1
          }
        },
        line: 1
      }
    },
    branchMap: {
      "0": {
        loc: {
          start: {
            line: 2,
            column: 2
          },
          end: {
            line: 2,
            column: 23
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 2,
            column: 2
          },
          end: {
            line: 2,
            column: 23
          }
        }, {
          start: {
            line: 2,
            column: 2
          },
          end: {
            line: 2,
            column: 23
          }
        }],
        line: 2
      },
      "1": {
        loc: {
          start: {
            line: 3,
            column: 2
          },
          end: {
            line: 6,
            column: 3
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 3,
            column: 2
          },
          end: {
            line: 6,
            column: 3
          }
        }, {
          start: {
            line: 3,
            column: 2
          },
          end: {
            line: 6,
            column: 3
          }
        }],
        line: 3
      }
    },
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0
    },
    f: {
      "0": 0
    },
    b: {
      "0": [0, 0],
      "1": [0, 0]
    },
    _coverageSchema: "43e27e138ebf9cfc5966b082cf9a028302ed4184"
  },
      coverage = global[gcv] || (global[gcv] = {});

  if (coverage[path] && coverage[path].hash === hash) {
    return coverage[path];
  }

  coverageData.hash = hash;
  return coverage[path] = coverageData;
}();

export default function (callback) {
  cov_1khmcguwtd.f[0]++;
  cov_1khmcguwtd.s[0]++;

  if (!callback) {
    cov_1khmcguwtd.b[0][0]++;
    cov_1khmcguwtd.s[1]++;
    return;
  } else {
    cov_1khmcguwtd.b[0][1]++;
  }

  cov_1khmcguwtd.s[2]++;

  if (document.readyState !== 'loading') {
    cov_1khmcguwtd.b[1][0]++;
    cov_1khmcguwtd.s[3]++;
    callback();
  } else {
    cov_1khmcguwtd.b[1][1]++;
    cov_1khmcguwtd.s[4]++;
    document.addEventListener('DOMContentLoaded', callback);
  }
}